import { ImportProductsXlsxTranslation } from "#i18n/translations/pt-BR/place/products/import-products-xlsx";

export const IMPORT_PRODUCTS_XLSX_FR_FR: ImportProductsXlsxTranslation = {
	header: {
		title: "Importer des produits",
		bulkEditTitle: "Modifier les produits en masse",
	},
	layout: {
		importProductsTable: "Importer votre tableau de produits",
		tutorial:
			"Ajoutez un ou plusieurs produits à la fois en important une feuille de calcul.",
		bulkEditTutorial:
			"Modifiez un ou plusieurs produits à la fois via la feuille de calcul.",
	},
	form: {
		totalProducts: "Total de produits",
		successfullyImported: "Produits importés",
		productsWithErrors: "Produits avec erreurs",
		alert: {
			title: "Produits avec erreurs",
			message:
				"Nous avons identifié des produits avec des informations incorrectes. Téléchargez la feuille de calcul avec les erreurs, corrigez les données, puis importez à nouveau.",
		},
		tooltip: {
			totalProducts: "Votre tableau avait {{totalProducts}} produits",
			successfullyImported: "{{totalProducts}} produits ont déjà été ajoutés avec succès",
			productsWithErrors: "Téléchargez le tableau avec les erreurs et importez à nouveau",
		},
		warning: {
			title: "Attention",
			description:
				"Les valeurs des produits sont entrées en centimes, ex: 123 équivaut à 1,23 €",
		},
		importProductsActiveByDefault: "Importer les produits avec le statut actif",
	},
	sheet: {
		columns: {
			name: "Nom",
			systemProductId: "Produit du Système",
			category: "Catégorie",
			menuCategory: "Catégorie du menu",
			description: "Description",
			image: "Image (ID)",
			imagePreview: "Image (visualisation)",
			imageIndex: "Image (indice)",
			existingImage: "Image originale",
			basicStorageUnit: "Unité de mesure",
			price: "Prix",
			priceInCents: "Prix en centimes",
			bars: "Bars (séparés par point et virgule)",
			hasAlcohol: "Contient-il de l'alcool ?",
			isHiddenFromApp: "Ne pas afficher le produit dans l'application ZigApp",
			fiscalCode: "SKU",
			fiscalNcm: "Fiscal - NCM",
			fiscalCest: "Fiscal - CEST",
			fiscalProductGroup: "Fiscal - Groupe fiscal",
			fiscalProfile: "Fiscal - Profil fiscal",
			fiscalIcmsBaseCalculoRetSt:
				"Fiscal - Base de calcul de l'ICMS retenu lors de l'opération précédente",
			fiscalIcmsValorSubistituto: "Fiscal - Valeur de l'ICMS propre du substitut",
			fiscalIcmsAliquotaFinal: "Fiscal - Taux supporté par le consommateur final",
			isStockable: "Stockable",
			beerBrand: "Marque de la bière",
			beerStyle: "Style de la bière",
			beerAbv: "ABV - Taux d'alcool",
		},
		sampleFileName: "exemple_importation_produits",
		errorFileName: "importation_produits_avec_erreurs",
		auxiliarSheets: {
			bars: "Bars",
			images: {
				ptBr: "PT-BR",
				esMx: "ES-MX",
				id: "ID",
				url: "URL",
				name: "Images",
			},
		},
	},
	upload: {
		warning: {
			title: "Attention",
			description:
				"Utilisez uniquement la feuille téléchargée depuis ce place. Les feuilles exportées d'autres places ne sont pas acceptées.",
		},
	},
	button: {
		continue: "Continuer l'Importation",
		validating: "Validation...",
		cancel: "Annuler",
	},
};
